import { useMemo } from 'react';
import { formatPhoneNumber } from '../common/formatting/phoneFormat';
import { Box, CopyToClipboard, Link } from '@cloudscape-design/components';

export type EmailProps = {
  email?: string | null;
}

export function Email(props: EmailProps) {
  const { email } = props;

  const formattedEmail = useMemo(() => {
    return `${email ? email : '-'}`;
  }, [email]);

  return email ? (
    <Link href={`mailto:${email}`}>{formattedEmail}</Link>
  ) : (
    <Box variant="span">{formattedEmail}</Box>
  );
}
